import { useEffect, useState } from "react";
import { apiClient } from "../lib/api";
import type { Party } from "../lib/types";

interface UseParty {
  party: Party | null;
  isLoading: boolean;
  error: string | null;
}

export function useParty(slug: string | undefined): UseParty {
  const [party, setParty] = useState<Party | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!slug) return;

    const controller = new AbortController();
    setIsLoading(true);
    setError(null);

    apiClient
      .get<Party>(`/api/parties/${slug}`)
      .then(setParty)
      .catch((err: unknown) => {
        if (!controller.signal.aborted) {
          setError(err instanceof Error ? err.message : "Failed to load party");
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      });

    return () => controller.abort();
  }, [slug]);

  return { party, isLoading, error };
}
